import { apiClient as api } from '../../../shared/api/axios-instance';

export const smsService = {

  getTemplateVersions: (templateId: string) => 
    api.get(`/internal/sms/templates/${templateId}/versions`),
    
  createTemplate: (data: { name: string; content: string; dlt_id?: string }) => 
    api.post('/internal/sms/templates', data),

  createTemplateVersion: (templateId: string, data: { content: string; dlt_id?: string }) =>
    api.post(`/internal/sms/templates/${templateId}/versions`, data),

  markVersionDefault: (templateId: string, versionId: string) =>
    api.put(`/internal/sms/templates/${templateId}/versions/${versionId}/default`),

  getLogs: (params: { start_date: string; end_date: string; limit?: number }) =>
    api.get('/internal/sms/logs', { params }),

  getAnalytics: (params: { start_date: string; end_date: string }) =>
    api.get('/internal/sms/analytics', { params })
};

